import { Text, Heading } from "../../components";
import UIBackgroundImg from '../../assets/img_frame_313692.webp';
import UserInterfaceComponent from "../../components/UserInterfaceComponent";
import React, { Suspense } from "react";

const solutionFeaturesList = [
  {
    headingText: "End to End Solution",
    descriptionText:
      "Right from individual machine efficiency to order tracking and process optimization. No need for multiple disconnected solutions, which means all data flows smoothly to inform your decisions.",
  },
  {
    headingText: "Open Source Technologies",
    descriptionText:
      "All our solutions are developed with open-source technologies ensuring the safety of your data. Embrace the power of open source for enhanced transparency, security, and innovation.",
  },
  {
    headingText: "Process Optimization",
    descriptionText:
      "Streamline workflows, eliminate bottlenecks, and improve operational efficiency. Our tools help you identify opportunities for optimization at every stage of your production line.",
  },
];

export default function OfferingsSection() {
  return (
    <>
      {/* offerings section */}
      <div>
        <div className="flex items-center justify-center bg-white bg-cover bg-no-repeat py-[152px] md:h-auto md:py-[60px] sm:px-2.5 min-h-[500px] sm:min-h-[400px]"
          style={{ backgroundImage: `url(${UIBackgroundImg})`}}>
          <div className="container-xs mb-1.5 flex justify-center px-2 md:px-5">
            <div className="flex flex-wrap w-full justify-center gap-[26px] md:gap-[20px] sm:gap-[15px] sm:px-3">
              <Suspense fallback={<div>Loading feed...</div>}>
                {solutionFeaturesList.map((d, index) => (
                  <UserInterfaceComponent {...d} key={"featuresList" + index} />
                ))}
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
